import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed w-full bg-black/95 border-b border-zinc-800 shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <img src="/logo.png" alt="SIXONE PRODUCTION Logo" className="h-8 md:h-10 w-auto mr-2 md:mr-3" />
            <span className="text-base sm:text-lg md:text-2xl font-serif text-white tracking-widest">SIXONE<span className="text-gold">PRODUCTIONS</span></span>
          </div>
          
          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="#home" className="text-gray-300 hover:text-gold text-sm uppercase tracking-wider transition">Home</a>
            <a href="#about" className="text-gray-300 hover:text-gold text-sm uppercase tracking-wider transition">About Us</a>
            <a href="#services" className="text-gray-300 hover:text-gold text-sm uppercase tracking-wider transition">Services</a>
            <a href="#contact" className="border border-gold text-gold px-6 py-2 hover:bg-gold hover:text-black transition uppercase tracking-wider text-sm">Contact Us</a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center shrink-0 ml-2">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gold focus:outline-none">
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black border-t border-zinc-800">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a href="#home" onClick={() => setIsOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-gold uppercase tracking-wider text-sm">Home</a>
            <a href="#about" onClick={() => setIsOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-gold uppercase tracking-wider text-sm">About Us</a>
            <a href="#services" onClick={() => setIsOpen(false)} className="block px-3 py-2 text-gray-300 hover:text-gold uppercase tracking-wider text-sm">Services</a>
            <a href="#contact" onClick={() => setIsOpen(false)} className="block px-3 py-2 text-gold font-bold uppercase tracking-wider text-sm">Contact Us</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;